'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (typeof require.ensure !== 'function') require.ensure = function (d, c) {
    c(require);
};

var UpdatePasswordModalLoader = function (_Component) {
    (0, _inherits3.default)(UpdatePasswordModalLoader, _Component);

    function UpdatePasswordModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, UpdatePasswordModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UpdatePasswordModalLoader.__proto__ || (0, _getPrototypeOf2.default)(UpdatePasswordModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(UpdatePasswordModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                require.ensure([], function () {
                    resolve(require('./UpdatePasswordModalContainer'));
                }, 'UpdatePasswordModal');
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return UpdatePasswordModalLoader;
}(_react.Component);

exports.default = UpdatePasswordModalLoader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/UpdatePasswordModal/UpdatePasswordModalLoader.js
// module id = U847
// module chunks = 57